const API_URL = process.env.NODE_ENV === 'development'
  ? '/api/api.php'
  : 'https://myblrc.in/api/api.php';

export class VisitorApiError extends Error {
  constructor(message) {
    super(message);
    this.name = 'VisitorApiError';
  }
}

async function getVisits(query) {
  const token = localStorage.getItem('adminToken') || '';
  const params = new URLSearchParams({ xAction: 'getVisitors', _t: Date.now().toString() });
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value) !== '') {
      params.set(key, String(value));
    }
  });
  if (token) params.set('token', token);

  const response = await fetch(`${API_URL}?${params.toString()}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
    cache: 'no-store',
  });

  let result;
  try {
    result = await response.json();
  } catch (error) {
    throw new VisitorApiError('Server returned an invalid response. The visitor API may not be deployed yet.');
  }

  if (result.status === 'error' || result.data?.status === 'error') {
    let message = result.data?.message || result.message || 'Unable to load visitor activity.';
    if (/invalid action/i.test(message)) {
      message = 'The visitor listing API is not deployed yet. Upload the updated api folder to myblrc.in.';
    }
    throw new VisitorApiError(message);
  }

  return result.data || result;
}

export function getVisitorVisits({ page = 1, limit = 20, search = '', filter = 'all', visitorType = 'all' } = {}) {
  return getVisits({
    page,
    limit,
    search,
    filter,
    visitor_type: visitorType,
  });
}
